import styled from '@emotion/styled';
import { Divider, device, typography } from '@landsbankinn/ui';
import React from 'react';

const StyledDivider = styled(Divider)`
  margin-bottom: 25px;
`;

const StyledTitle = styled.h2`
  ${typography.h2}
  margin-bottom: 31px;
`;

const Body = styled.p`
  ${typography.body}
  margin-bottom: 48px;
  @media ${device.tablet} {
    margin-bottom: 0px;
  }
`;

interface IProps {
  title?: string;
  subTitle?: string;
  className?: string;
}

export function Title({ title, subTitle, className }: IProps) {
  return (
    <div className={className}>
      <StyledTitle>{title}</StyledTitle>
      <StyledDivider />
      {subTitle && <Body>{subTitle}</Body>}
    </div>
  );
}
